const categoriesDisplayLabel = [
  {
    categorySlug: 'membership',
    displayName: 'Membership',
    displayOrder: 1,
    enabled: true
  },
  {
    categorySlug: 'account-and-billing',
    displayName: 'Account',
    displayOrder: 2,
    enabled: true
  },
  {
    categorySlug: 'devices',
    displayName: 'Devices & Features',
    displayOrder: 3,
    enabled: true
  },
  {
    categorySlug: 'classes-and-series',
    displayName: 'Content & Instructors',
    displayOrder: 4,
    enabled: true
  }
]

export const getCategoriesDisplay = (slug) => {
  const category = categoriesDisplayLabel.find(
    (category) => category.categorySlug === slug
  )
  if (category) {
    return category.displayName
  }
  return slug.replace(/-/g, ' ')
}
